export enum RecruitingDashboardAlertType {
    Leads = 1,
    FollowUps = 2,
    JobInterests = 3,
    Birthdays = 4,
    Hot = 5,
    PreStart = 6,
    Live = 7,
    Working = 8,
    AllTiles = 9,
    JobAlerts = 10,
    SelfApply = 11
}
